import { createContext } from 'react';

type SnapSiteConfigEditContextType = {
  marketCodes: string[];
  discountCodes: string[];
};

export const SnapSiteConfigEditContext =
  createContext<SnapSiteConfigEditContextType | null>(null);
